import React, { useEffect } from 'react'

import useStudentPreChecks from '../../useStudentPreChecks'
import StudentInstruction from '../../Components/StudentInstruction'
import { PRE_CHECK_MACHINE_STATES } from '../../constants'

import { COPY_STRINGS } from '../../../../constants/translatedCopy'
import { ASR_EVENTS } from '../StudentASRConstants'

export default React.memo(function TeacherTestResultSuccess({speechProps, endASRCheck, hasHighBackgroundNoise}) {

    const studentPreCheck = useStudentPreChecks({ itemToCheck: PRE_CHECK_MACHINE_STATES.studentASRChecks })

    useEffect(()=>{
        studentPreCheck.logEvent(ASR_EVENTS.TEACHER_TEST_SUCCESS)
        if(hasHighBackgroundNoise){
            studentPreCheck.logEvent(ASR_EVENTS.TEACHER_TEST_BG_NOISE_DETECTED)
        }
        speakPrompt()
        
        return () => {
            speechProps.abortSpeech()
        }
    }, [])

    const speakPrompt = async () => {
        if(hasHighBackgroundNoise){
            await speechProps.speakWithPromise({textToSpeak: COPY_STRINGS.student_checks.teacher_mode_asr_failure_high_bgn_one})
        }else{
            await speechProps.speakWithPromise({textToSpeak: COPY_STRINGS.student_checks.teacher_mode_asr_failure_flagging_prompt_one})
        }
    }

    const flagStudent = async (shouldFlag) => {
        speechProps.abortSpeech()
        if(shouldFlag){
            studentPreCheck.logEvent(ASR_EVENTS.FLAG_HARD_TO_UNDERSTAND)
            await speechProps.speakWithPromise({textToSpeak: COPY_STRINGS.student_checks.teacher_mode_asr_failure_flagging_prompt_yes_one})
        }else{
            studentPreCheck.logEvent(ASR_EVENTS.SKIP_FLAG_HARD_TO_UNDERSTAND)
            await speechProps.speakWithPromise({textToSpeak: COPY_STRINGS.student_checks.teacher_mode_asr_failure_flagging_prompt_no_one})
        }
        endASRCheck()
    }

    if(!hasHighBackgroundNoise){
        return <StudentInstruction>
            <h2>Do you have trouble understanding this student's speech?</h2>
            <div className='__inline-buttons'>
                <button onClick={()=>flagStudent(true)}>Yes</button>
                <button onClick={()=>flagStudent(false)}>No</button>
            </div>
            <p>Clicking yes will qualify this student for extra review of their assessments.</p>
        </StudentInstruction>
    }

    return <StudentInstruction>
        <h2>There seems to be significant background noise, please remind the student to speak clearly into the microphone.</h2>
        <button onClick={endASRCheck}>Start Reading</button>
    </StudentInstruction>
})